export default `
## QUADRO RESUMO

|   |   |
| - | - |
| **Nome do Contratante** | {{fullName}}  | 
| **CPF** | {{cpf}}  | 
| **Endereço** | {{address}}  | 
| **Email** | {{email}}  | 
| **Telefone** | {{phoneNumber}}  | 
| **Estado Civil** | {{marritalStatus}}  | 
| **Número de Associados** | {{associateQuantity}}  | 
| **Valor Mensal do Plano por Associado** | {{pricePerAssociate}}  | 
| **Valor mensal total do plano** | {{membershipPrice}}  | 
| **Data de início** | {{startDate}}  | 
| **Dia de Vencimento de cada parcela** | {{renewalDate}}  | 
| **Índice de correção do reajuste anual** | {{priceReadjustment}}  | 


Pelo presente Contrato de Prestação de Serviços (“Contrato”) e na melhor forma de direito, as partes:

**(a) {{fullNameUppercase}}**, já qualificado no Quadro Resumo, doravante simplesmente denominada como “Contratante”; e

**(b) HEALTH ATENDIMENTO DE SAÚDE RESPONSÁVEL LTDA**, sociedade empresária de responsabilidade limitada com sede na Cidade de São Paulo, Estado de São Paulo, na Avenida Brigadeiro Faria Lima, n° 2369, andar 11 – Conj 1102 – Jardim Paulistano, CEP 01452922, inscrita no CNPJ/ME sob o n° 40.998.165/0001-19, neste ato representada na forma do seu Contrato Social, doravante simplesmente denominada como “Contratada” e em conjunto com o Contratante denominados “Partes”.

**CONSIDERANDO QUE:**

**(i)** A Contratada é uma empresa que oferece benefício de saúde por teleatendimento entre pacientes e profissionais de saúde em todo o Brasil (“Plataforma”);

**(ii)** A Contratada **NÃO É** uma seguradora; e

**(iii)** O Contratante tem interesse em contratar os Serviços da Contratada para as pessoas determinadas neste Contrato (“Associados”).

**RESOLVEM** as Partes celebrar o presente Contrato, entre si segundo as cláusulas e condições adiante apontadas, que em caráter recíproco estabelecem:

1. **OBJETO**

**1.1.** A Contratada é uma empresa que oferece benefícios de saúde por meio de teleatendimento, acompanhamento proativo e coordenação dos cuidados necessários da saúde do Contratante (“Serviços”) por profissionais de saúde devidamente habilitados (“Profissionais”).

**1.1.1.** No Anexo I o Contratante encontra a lista dos Serviços oferecidos pela Contratada

**1.1.2.** O Anexo II traz uma lista exemplificativa, mas não exaustiva, dos serviços que NÃO são prestados pela Contratada.

**1.1.3.** No Anexo III encontra-se a lista de Associados beneficiados.

**1.2.** Os Serviços serão prestados pela Contratada a partir do momento da assinatura deste Contrato e até a sua rescisão, não havendo nenhum tipo de carência necessária para aproveitamento pelo Contratante.

1.3.\*\* Os Serviços serão prestados apenas para as pessoas indicadas como Associados, nos termos do Anexo III.

**1.4.** Os Serviços não constituem um seguro de saúde e não implicam, de nenhuma forma, no reembolso de valores, pagamento de despesas médicas, entrega de medicamentos, realização de exames, cirurgias ou procedimentos ou qualquer outra atividade que não o atendimento clínico de seus Profissionais.

**1.5.** O Contratante deverá manter seu cadastro atualizado perante a Contratada, não podendo a contratada ser responsabilizada por qualquer falha na prestação dos Serviços decorrente de dados pessoais do Contratante desatualizados.

2.  **DO ATENDIMENTO**

**2.1.** Os Serviços serão realizados preferencialmente por meio da Plataforma da Contratada (“Plataforma”), podendo, por exclusiva vontade e discricionariedade do Contratante ou de seus Profissionais, ser realizada por outros meios como telefone, WhatsApp ou presencialmente.

**2.2.** O Contratante poderá utilizar os Serviços de qualquer lugar do Brasil, não havendo limitação geográfica dentro do território brasileiro.

**2.3.** Não há limitação de uso dos Serviços pelo Associado, mas consultas eletivas, não relacionadas a emergências médicas, serão realizadas apenas em horários comerciais pré-determinados pela Contratada.

**2.4.** Apesar das limitações deste Contrato, os Profissionais da Contratada poderão determinar, em casos específicos, horários e formas diferenciadas de atendimento, de acordo com a necessidade do Associado.

**2.5.** Mais informações sobre o atendimento estão disponíveis Anexo I, que faz parte deste Contrato.

3.  **REMUNERAÇÃO**

**3.1.** Pela prestação dos Serviços o Contratante pagará à Contratada o valor mensal descrito no Quadro Resumo.

**3.2.** O pagamento deverá ser realizado por Cartão de Crédito, na data de vencimento descrita no Quadro Resumo.

**3.2.1.** Em caso de atraso no pagamento, incidirão multa de 2% (dois por cento) e juros de 1% (um por cento) ao mês sobre o valor a ser pago, desde a data de vencimento da parcela até o efetivo pagamento.

**3.2.2.** Caso o pagamento não seja efetuado integralmente em até 90 (noventa) dias após a data de vencimento da parcela, todos os serviços objeto do presente Contrato serão suspensos até o efetivo pagamento para todos os planos contratados, não sendo a Contratada responsável por qualquer dano material ou moral resultante dessa interrupção.

**3.3.** O valor da parcela será corrigido anualmente, pela variação positiva dos últimos 12 (doze) meses do Índice de Preços ao Consumidor Amplo (IPCA) ou pelo índice que venha a substituí-lo.

4.  **VIGÊNCIA E RESCISÃO**

**4.1.** O presente Contrato vigerá por prazo indeterminado.

**4.2.** As Partes poderão rescindir unilateralmente o presente Contrato mediante notificação por escrito à outra Parte, com antecedência mínima de 30 (trinta) dias.

5.  **ISENÇÃO DE RESPONSABILIDADE DA CONTRATADA**

**5.1** A Contratada compromete-se a prestar os Serviços em conformidade com os termos e condições deste Contrato e da técnica, não se responsabilizando, entretanto, por eventual interrupção ou indisponibilidade temporária da Plataforma ou pelo atendimento, opinião ou qualquer manifestação dos Profissionais – médicos, enfermeiros ou profissionais de saúde – que serão os únicos responsáveis pelas consultas, orientações ou atendimentos realizados.

**5.2** A Contratada se compromete a verificar no ato de cadastro dos profissionais de Saúde, se estes possuem cadastro ativos junto aos conselhos regionais relativos à profissão e os orientará, sem compromisso de responsabilidade, de seguir os princípios éticos da profissão, inclusive no que tange à privacidade das informações.

6.  **SIGILO**

**6.1** Ressalvadas as exigências da lei ou qualquer outra convenção das Partes em sentido contrário, A Contratada obriga-se a:

**6.1.1.** Conservar em caráter de confidencialidade todas e quaisquer Informações Confidenciais, não as revelando a quaisquer terceiros;

**6.1.2.** Não utilizar as Informações Confidenciais para qualquer outro fim além do objeto deste Contrato, seja em benefício próprio ou de terceiros;

**6.1.3.** Não fazer quaisquer cópias ou duplicar, imprimir ou de outro modo reproduzir quaisquer Informações Confidenciais, exceto no estrito limite necessário à prestação dos Serviços.

**6.1.4.** Para os fins deste Contrato, caracterizam-se “Informações Confidenciais” como: quaisquer documentos, e-mails, informações (escritas ou verbais) ou dados referentes ao Contratante.

**6.2** A obrigação de confidencialidade aqui prevista não será aplicável quando as informações:

**6.2.1.** Forem ou venham se tornar de conhecimento público por qualquer razão que não seja em decorrência de ato praticado em violação deste Contrato;

**6.2.2.** Sejam reveladas por exigência legal ou ordem judicial, desde que antes de fazer a divulgação, notifique a outra Parte para que a mesma tome conhecimento da situação e possa tomar as providências que entender necessárias para evitar a divulgação;

**6.2.3.** Forem legalmente reveladas por terceiros que não tiveram acesso à informação sob a vigência deste Contrato ou obrigação de confidencialidade prevista em outro instrumento; e

**6.2.4.** Tenham a sua divulgação autorizada, por escrito, pelo Contratante.

**6.3** O não cumprimento das disposições previstas nesta Cláusula acarretará na responsabilização civil da Contratada e esta será obrigada a ressarcir quaisquer prejuízos decorrentes do seu inadimplemento, limitado ao valor total de R$ 1.000,00 (um mil reais). A sanção cominada nesta Cláusula inclui indenização por danos morais e materiais e multa punitiva.

**6.4** Quando não previsto em legislação específica, as obrigações de confidencialidade e sigilo previstas neste Contrato entrarão em vigor com a assinatura e assim permanecerão durante o prazo de 5 (cinco) anos, após a conclusão dos Serviços.

7.  **POLÍTICA DE TRATAMENTO DE DADOS**

**7.1** A Contratada, por si ou através de seus representantes, diretores, prepostos, empregados, colaboradores, contratados ou sucessores, através da assinatura do presente contrato, declara, garante e compromete-se, em qualquer questão relacionada direta ou indiretamente com o desenvolvimento das atividades necessárias ao cumprimento do objeto deste contrato, que: (i) atua e cumpre com as disposições legais e demais determinações de órgãos oficiais em matéria de proteção dedados pessoais, relativos a uma pessoa física identificada ou identificável (“Dados Pessoais”), em especial a Lei de no 13.709/2018 (“Lei Geral de Proteção de Dados”), assim como as demais normas de proteção de Dados Pessoais do pais onde realiza o tratamento destes; (ii) Declara de forma irrevogável e irretratável, que seus acionistas/quotistas/sócios, conselheiros, administradores, diretores, empregados, prestadores de serviços, inclusive seus subcontratados e prepostos, conhecem e cumprem integralmente o disposto nas leis, regulamentos e disposições normativas que tratam da proteção de Dados Pessoais, nacionais e estrangeiras; (iii) Se absterá de realizar qualquer tratamento indevido, irregular ou ilegal, de forma direta e/ou indireta, ativa e/ou passiva, de Dados Pessoais.

**7.1.1.** Para fins do presente Contrato, a expressão “tratamento” significa toda operação realizada com Dados Pessoais, como as que se referem a coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou extração.

**7.1.2.** A Contratada poderá contratar terceiros para realizarem o tratamento de dados do Contratante, mas serão tomados todos os cuidados necessários para que estes terceiros sigam as disposições deste Contrato sobre privacidade e tratamento de dados.

**7.1.3.** O Contratante se declara responsável legal pelos dependentes menores de idade, permitindo à Contratada realizar o tratamento dedados destes menores para fins deste Contrato.

**7.2.** Sem prejuízo das demais obrigações previstas neste contrato, a Contratada compromete-se a:

**7.2.1.** Realizar o monitoramento e registro, de forma adequada, da sua conformidade em relação à Lei Geral de Proteção de Dados e, quando solicitado pela outra Parte, fornecer documentação hábil para comprovação;

**7.2.2.** Manter a mais absoluta confidencialidade e sigilo dos Dados Pessoais que vier a ter acesso em decorrência deste Contrato e como mesmo nível de segurança que trata seus dados e informações de caráter confidencial, ainda que este contrato seja resolvido e independentemente dos motivos que deram causa ao seu término ou resolução;

**7.2.3.** Garantir o exercício dos direitos dos Titulares de acordo com a legislação de proteção de Dados Pessoais aplicável; e

**7.2.4.** Utilizar os Dados Pessoais somente para os fins descritos no presente contrato, sendo vedada a utilização destes para finalidades diversas.

8.  **COMUNICAÇÕES**

**8.1.** Todas as notificações e outras comunicações realizadas nos termos deste Contrato deverão ocorrer por escrito e serão consideradas como efetivamente realizadas: (i) por meio de e-mail, ou entrega em mãos (quando física) à parte a ser notificada, ou (ii) 10 (dez) dias após terem sido enviadas por carta registrada, com aviso de recebimento ou por telegrama. A ocorrência dos eventos estabelecidos nos itens (i) e (ii) acima será considerada “entrega” de notificação para todos os efeitos de direito. Todas as notificações e outras comunicações deverão ser enviadas às respectivas partes nos endereços estabelecidos no preâmbulo deste Contrato.

**8.2.** As Partes estabelecem, de comum acordo, que as notificações serão consideradas entregues em mãos e válidas, ainda que o recebimento ou comprovante da entrega seja assinado por outra pessoa que não a própria parte, incluindo, sem limitação, por outra pessoa residente no local ou pessoa responsável pela portaria, recepção ou equivalente.

9.  **DISPOSIÇÕES GERAIS**

**9.1.** Este Contrato vincula as Partes, seus representantes legais e sucessores, a qualquer tempo ou a qualquer título.

**9.2.** Caso qualquer disposição do presente Contrato seja considerada nula, ilegal ou inexequível, este Contrato não será anulado, continuando em vigor as demais cláusulas. Neste caso, as Partes deverão promover uma negociação de boa-fé, de forma a chegarem a um acordo na redação de uma nova cláusula que seja satisfatória, preserve o equilíbrio econômico entre as Partes, e a qual reflita suas intenções, conforme expressas no presente Contrato, substituindo aquela considerada nula, ilegal ou inexequível.

**9.3.** Quaisquer entendimentos sobre modificações ou alterações deste Contrato deverão ser efetuados por meio de documento escrito e assinado por ambas as Partes.

**9.4.** Qualquer omissão ou tolerância de qualquer uma das Partes em exigir o fiel cumprimento dos termos e condições deste Contrato, não constituirá novação ou renúncia, nem afetará o direito da Parte de exigir seu cumprimento a qualquer tempo. Os direitos e obrigações decorrentes do presente Contrato não poderão ser cedidos ou transferidos a terceiros sem que haja a expressa anuência da outra Parte.

10. **FORO**

**10.1** As partes elegem o foro da Comarca de São Paulo para dirimir quaisquer dúvidas deste Instrumento, renunciando a qualquer outro por mais privilegiado que seja.

E, por estarem justas e contratadas, firmam o presente em 2 (duas) vias de igual teor.


#### São Paulo.
#####
### **{{fullNameUppercase}}**
#####
### **HEALTH ATENDIMENTO DE SAÚDE RESPONSÁVEL LTDA**

#### Por: Víctor Cussiol Macul
#### Sócio Fundador da Ana Health
#### CPF: 383.828.558-14

(Data de assinatura consta na última página deste contrato conforme a certificação digital.)

### ANEXO I

### LISTA DE SERVIÇOS PRESTADOS

A Contratada disponibilizará ao Contratante serviços médicos clínicos focados na prestação de cuidados de saúde primários a pessoas de qualquer sexo e idade, com as seguintes características:

- **Equipe de saúde dedicada**: uma equipe multidisciplinar que prestará atendimento de forma individualizada. Esta equipe conta com uma médica, uma enfermeira e uma agente de saúde, dedicadas. Esta equipe ficará disponível em dias úteis das 8h00 às 22h00.

- **Equipe de Plantão**: Equipe que prestará o atendimento nos horários fora do horário de atendimento da Equipe de saúde dedicada – 22h00 às 8h00 e em dias não-úteis.

- **Acompanhamento proativo**: Elaboração de plano de cuidado individual para acompanhamento de forma proativa, com o auxílio da tecnologia.

- **Atendimento remoto ilimitado**: Atendimento por ligação, mensagem de texto, e-mail ou videochamada, para qualquer demanda de saúde. A equipe de saúde tem autonomia para definição da conduta mais adequada a cada situação e poderá sugerir ou rejeitar formas específicas de atendimento, em razão da necessidade do paciente.

- **Histórico da sua Saúde**: Prontuário eletrônico com foco em medicina preventiva e personalizada garante acesso às informações médicas e de saúde relacionadas ao seu histórico de atendimento.

### ANEXO II

LISTA DE SERVIÇOS QUE NÃO SÃO OFERECIDOS

- Exames laboratoriais e de imagem;

- Procedimentos cirúrgico e internações;

- Serviços de pronto-socorro (emergência);

- Medicamentos;

- Atendimento presencial; e

- Acesso a especialistas focais (cardiologista, ortopedista, obstetrícia etc).

### ANEXO III

## ASSOCIADO

|   |   |
| - | - |
| **Nome** | {{fullName}}  | 
| **CPF** | {{cpf}}  | 
| **Endereço** | {{address}}  | 
| **Email** | {{email}}  | 
| **Telefone** | {{phoneNumber}}  | 
| **Data de Nascimento** | {{birthDate}}  | 
| **Relação com o Contratante** | N/A | 
`;
